const starRatingStyles = {
  empty: '#D5DBDB',
  border: '#AC6518',
  fill: '#F9CF2F',
};

export default starRatingStyles;
